import React, { Fragment } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { show } from "redux-modal";
import { IconButton, ActionsMenuLarge } from "@conserveit/blocks";
import { history } from "../../../browserHistory";
import { unassociateEquipRule } from "../../../redux/modules/_BETA/unassociate";
import Menu from "../../Menu";
import { $ButtonItem, $Menu, $MenuTitle } from "../../Menu/Menu.styles";

const $Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

function showList({ isOpen }) {
  return isOpen ? "block" : "none";
}
const $List = styled($Menu)`
  display: ${showList};
  left: auto;
  right: 0;
  top: 0;
`;

const RowAction = ({
  className,
  equipRuleId,
  equipName,
  siteId,
  ruleName,
  showModal,
  onMenuToggle,
  isAssociated,
  unassociate,
  isHidden,
}) => (
  <Menu onToggle={onMenuToggle}>
    {({ isOpen, menuRef, toggle, close }) => (
      <$Wrapper className={className} ref={menuRef} hidden={isHidden}>
        <IconButton icon={<ActionsMenuLarge />} onClick={toggle} />
        <$List isOpen={isOpen}>
          {/* TODO: Uncomment once watch functionality exists */}
          {/* <$MenuTitle>ACTIONS</$MenuTitle>
          <$ButtonItem type="button">Watch</$ButtonItem> */}
          {/* TODO: Uncomment and hook up once we've got a link to the rule-specific skyspark route */}
          {/* <$ButtonItem type="button">View Analytics for Rule</$ButtonItem> */}
          <$MenuTitle>Action</$MenuTitle>
          {!isAssociated && (
            <Fragment>
              <$ButtonItem
                type="button"
                onClick={() => {
                  history.push("/actions/add", {
                    equips: [{ equipRuleId, equipName }],
                    rule: ruleName,
                    site: siteId,
                  });
                }}
              >
                Associate to new Action
              </$ButtonItem>
              <$ButtonItem
                type="button"
                onClick={showModal(equipRuleId, equipName, close)}
              >
                Associate to existing Action
              </$ButtonItem>
            </Fragment>
          )}
          {isAssociated && (
            <$ButtonItem
              type="button"
              onClick={unassociate(equipRuleId, close)}
            >
              Unassociate from Action
            </$ButtonItem>
          )}
          {/* TODO: Uncomment and hook up once functionality exists */}
          {/* <$ButtonItem type="button">View all associated Tickets</$ButtonItem> */}
          {/* <$MenuTitle>SUPPORT</$MenuTitle>
          <$ButtonItem type="button">Report as Problem</$ButtonItem> */}
        </$List>
      </$Wrapper>
    )}
  </Menu>
);

function mapDispatchToProps(dispatch) {
  return {
    showModal:
      (equipRuleId, equipName, cb, createNewIssue = false) =>
      () => {
        dispatch(
          show("TRIAGE_ACTION_MODAL", {
            equipRuleIds: [equipRuleId],
            equipNames: [equipName],
            createNewIssue,
          })
        );
        if (typeof cb === "function") cb();
      },
    unassociate: (equipRuleId, cb) => () => {
      dispatch(unassociateEquipRule({ equipRuleIds: [equipRuleId] }));
      if (typeof cb === "function") cb();
    },
  };
}

export default connect(null, mapDispatchToProps)(RowAction);
